import { ViewFactory } from 'wdc-cube-react'

import { GroupManagerScope } from '../gm_scopes'

import { HeaderScope } from '../gm_scopes'
import HeaderView from './gm-header'
import GroupManagerView from './gm_view'

export function registerViews(rv = ViewFactory.register) {
    rv(GroupManagerScope, GroupManagerView)
    rv(HeaderScope, HeaderView)
}
